import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@core/models/api-response.model';
import { Injectable } from '@angular/core';
import { map, tap } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { Dropdown } from '@core/models/dropdown.model';

@Injectable()
export class CampaignHttpService {

  messages$ = new Subject<any[]>();
  constructor(private http: HttpClient) { }

  getUnpaginatedCampaign(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/campaign?status=1&paginate=false`).pipe(
      map(res => res.data.rows)
    );
  }

  importCampaignAdCost(file: any) {
    return this.http.post<ApiResponse>(`/campaign/adcost/importcsv`, file).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  getCampaignByCurrency(currencyId): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/campaign?status=1&currency_id=${currencyId}&paginate=false`).pipe(
      map(res => res.data.rows)
    );
  }
}

